import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { Product } from 'graphql-api/gql-api-interfaces';

import { upsertProducts } from './product-entities.actions';

export interface ProductEntity {
  product: Product;
}

export type ProductEntitiesState = EntityState<Product>;

export const adapter = createEntityAdapter<Product>({
  selectId: (product) => product.productId,
  sortComparer: false,
});

export const initial = adapter.getInitialState();
export const reducer = createReducer<ProductEntitiesState>(
  initial,
  on(upsertProducts, (state, { products }) => {
    return adapter.upsertMany(products, state);
  }),
);
